import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { FullScreenLoader } from '@ui/components/FullScreenLoader';
import { Navigate } from 'react-router';

import { loginRequest } from '../../config/authConfig';
import { EnvConfig } from '../../config/env';
import { useAuth } from '../../state/auth';
import { IdleLogout } from '../IdleLogout';
import { WithCurrentUser } from '../WithCurrentUser';
import { AuthErrorMessage } from './AuthError';

export function ProtectedRoute({ children }: { children: JSX.Element }) {
  const authRequest = { ...loginRequest };
  const { isLoggedOut, logout, user } = useAuth();

  const timeoutSeconds = Number.parseInt(
    EnvConfig.getKey('IDLE_TIMOUT_SECONDS') ?? '1800',
  );
  const promptBeforeSeconds = Number.parseInt(
    EnvConfig.getKey('IDLE_TIMEOUT_PROMPT_BEFORE_SECONDS') ?? '120',
  );

  return isLoggedOut ? (
    <Navigate to="/logout/redirect" />
  ) : (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      errorComponent={AuthErrorMessage}
      loadingComponent={AuthLoading}
    >
      <IdleLogout {...{ user, logout, timeoutSeconds, promptBeforeSeconds }} />
      <WithCurrentUser>{children}</WithCurrentUser>
    </MsalAuthenticationTemplate>
  );
}

function AuthLoading() {
  return <FullScreenLoader />;
}
